import React from "react";

export default function Gallery() {
  return (
    <div>
      <div className="container page-top">
        <div style={{ marginTop: "9rem" }} className="row">
          {/* Video 1 */}
          <div
            className="col-lg-6 col-md-8 col-xs-6 mb-4"
            data-aos="zoom-in"
            data-aos-duration="500"
            data-aos-delay="900"
            data-aos-easing="ease-in-quad"
          >
            <div className="embed-responsive embed-responsive-16by9">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/nOifTWBWDEE?si=W5E6dz84yPuHQiI4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>

          {/* Video 2 */}
          <div
            className="col-lg-6 col-md-8 col-xs-6 mb-4"
            data-aos="zoom-in"
            data-aos-duration="500"
            data-aos-delay="900"
            data-aos-easing="ease-in-quad"
          >
            <div className="embed-responsive embed-responsive-16by9">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/v_VyxyLk-Ds?si=WSeYt37O182ilqPU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>

          {/* Video 3 */}
          <div
            className="col-lg-6 col-md-8 col-xs-6 mb-4"
            data-aos="zoom-in"
            data-aos-duration="500"
            data-aos-delay="900"
            data-aos-easing="ease-in-quad"
          >
            <div className="embed-responsive embed-responsive-16by9">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/qd4P8BfHcWw?si=76PMp1zdxI_yw01X" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>

          {/* Video 4 */}
          <div
            className="col-lg-6 col-md-8 col-xs-6 mb-4"
            data-aos="zoom-in"
            data-aos-duration="500"
            data-aos-delay="900"
            data-aos-easing="ease-in-quad"
          >
            <div className="embed-responsive embed-responsive-16by9">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/dWvtqOk0seI?si=Q-HtSKihXpvuxKit" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>

          {/* Video 5 */}
          <div
            className="col-lg-6 col-md-8 col-xs-6 mb-4"
            data-aos="zoom-in"
            data-aos-duration="500"
            data-aos-delay="900"
            data-aos-easing="ease-in-quad"
          >
            <div className="embed-responsive embed-responsive-16by9">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/uZKh-JUp56M?si=x3GUB9CukhbL0Yvt" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>

          {/* Video 6 */}
          <div
            className="col-lg-6 col-md-8 col-xs-6 mb-4"
            data-aos="zoom-in"
            data-aos-duration="500"
            data-aos-delay="900"
            data-aos-easing="ease-in-quad"
          >
            <div className="embed-responsive embed-responsive-16by9">
<iframe width="560" height="315" src="https://www.youtube.com/embed/nz72LBaxS0Q?si=z-5qAJOTgTar04-N" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
